type EntitlementURI =
	| 'feature:invest:account:custodial:self'
	| 'feature:invest:account:custodial:robo'
	| 'feature:invest:account:retirement:self'
	| 'feature:invest:account:retirement:robo'
	| 'feature:invest:account:personal:robo'
	| 'feature:invest:account:personal:self'
	| 'feature:invest:stocks-and-etfs'
	| 'feature:bank:checking'
	| 'feature:content:report:standard'
	| 'feature:content:ai:money-coach'
	| 'feature:solutions:insurance:avibra:31000offer'
	| 'feature:content:content-moat'
	| 'feature:bank:card:premium'
	| 'feature:bank:stockback:merchant-bonus:premium'
	| 'feature:content:report:premium';

export type EntitlementRecord = {
	uri: EntitlementURI;
};

export const OPEN_ACCOUNT_CUSTODIAL_SELF: EntitlementURI = 'feature:invest:account:custodial:self';
export const OPEN_ACCOUNT_CUSTODIAL_ROBO: EntitlementURI = 'feature:invest:account:custodial:robo';
export const OPEN_ACCOUNT_RETIREMENT_SELF: EntitlementURI =
	'feature:invest:account:retirement:self';
export const OPEN_ACCOUNT_RETIREMENT_ROBO: EntitlementURI =
	'feature:invest:account:retirement:robo';
export const OPEN_ACCOUNT_PERSONAL_ROBO: EntitlementURI = 'feature:invest:account:personal:robo';
export const INVEST_STOCKS_AND_ETFS: EntitlementURI = 'feature:invest:stocks-and-etfs';
export const OPEN_ACCOUNT_PERSONAL_SELF: EntitlementURI = 'feature:invest:account:personal:self';
export const OPEN_ACCOUNT_BANKING: EntitlementURI = 'feature:bank:checking';
export const VIEW_CONTENT_REPORT_STANDARD: EntitlementURI = 'feature:content:report:standard';
export const VIEW_CONTENT_AI_MONEY_COACH: EntitlementURI = 'feature:content:ai:money-coach';
export const ACCESS_SOLUTION_INSURANCE_AVIBRA_31000OFFER: EntitlementURI =
	'feature:solutions:insurance:avibra:31000offer';
export const VIEW_CONTENT_CORE: EntitlementURI = 'feature:content:content-moat';
export const STOCK_BACK_PREMIUM: EntitlementURI = 'feature:bank:card:premium';
export const STOCK_BACK_MERCHANT_BONUS_PREMIUM: EntitlementURI =
	'feature:bank:stockback:merchant-bonus:premium';
export const VIEW_CONTENT_REPORT_PREMIUM: EntitlementURI = 'feature:content:report:premium';

export const hasEntitlement = (
	entitlements: EntitlementRecord[],
	entitlementUri: EntitlementURI
) => {
	if (!entitlements || !Array.isArray(entitlements)) {
		return false;
	}
	return entitlements.some((e) => e.uri === entitlementUri);
};
